// Trainings.js

import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Nav, Button, ButtonGroup } from 'react-bootstrap';
import UpcomingTrainings from './UpcomingTrainings';
import TrainingCalendar from './TrainingCalendar';
import ActionsSection from './ActionsSection';
import PaginationControls from './PaginationControls';
import { getUser } from '../utils/auth';

function Trainings() {
  const loggedInUser = getUser();
  // State to store upcoming trainings data
  const [upcomingTrainings, setUpcomingTrainings] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  const [filter, setFilter] = useState('current'); // 'previous', 'current' (current month), 'upcoming'
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [viewMode, setViewMode] = useState('list'); // 'list', 'calendar'
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Function to fetch upcoming trainings data
  /*
  const fetchUpcomingTrainings = () => {
    fetch(`${API_BASE_URL}/trainings/get_all_trainings.php`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch upcoming trainings');
        }
        return response.json();
      })
      .then(data => {
        console.log('Fetched upcoming trainings:', data);
        if (Array.isArray(data)) {
          setUpcomingTrainings(data);
        } else {
          console.error('Expected an array but got:', data);
          setUpcomingTrainings([]); // Fallback to an empty array
        }
        setLoading(false); // Set loading to false after fetching
      })
      .catch(err => {
        console.error('Error fetching upcoming trainings:', err);
        setError(err.message); // Set error message
        setLoading(false); // Set loading to false even on error
      });
  };
  */
  const fetchTrainings = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}/trainings/get_all_trainings.php?filter=${filter}&page=${page}&user_id=${loggedInUser.id}`, { credentials: 'include' })
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch trainings');
        return response.json();
      })
      .then(data => {
        console.log('Fetched upcoming trainings:', data);
        if (Array.isArray(data.trainings)) {
          setTrainings(data.trainings);
          setTotalPages(data.total_pages || 1);
        } else {
           console.error('Expected an array but got:', data);
          setTrainings([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching upcoming trainings:', err);
        setError(err.message);
        setLoading(false);
      });
  };

  // Function to handle deletion and update the trainings list
  const handleDeleteTraining = (deletedId) => {
    setTrainings(prev => prev.filter(training => training.id !== deletedId));
  };

  useEffect(() => {
    fetchTrainings();
  }, [filter, page]);


  return (
    <Container>
      <Row>
        <Col>
          <h1>Trainings</h1>
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md={8}>
          {viewMode === 'list' && (
            <Nav variant="tabs" activeKey={filter} onSelect={(key) => { setFilter(key); setPage(1); }}>
              <Nav.Item>
                <Nav.Link eventKey="upcoming">Upcoming Trainings</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="current">Current Month</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="previous">Previous Trainings</Nav.Link>
              </Nav.Item>
            </Nav>
          )}
        </Col>
        <Col md={4} className="text-end">
          <ButtonGroup>
            <Button variant={viewMode === 'list' ? 'primary' : 'outline-primary'} onClick={() => setViewMode('list')}>List</Button>
            <Button variant={viewMode === 'calendar' ? 'primary' : 'outline-primary'} onClick={() => setViewMode('calendar')}>Calendar</Button>
          </ButtonGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          {viewMode === 'calendar' ? (
            <TrainingCalendar />
          ) : (
            <>
              <h2>{filter === 'upcoming' ? 'Upcoming Trainings' : filter === 'previous' ? 'Previous Trainings' : 'Current Month'}</h2>
              {loading ? (
                <p>Loading...</p> // Display loading message while fetching
              ) : error ? (
                <p>Error: {error}</p> // Display error message if there is an error
              ) : (
                <>
                  <UpcomingTrainings trainings={trainings} onDeleteTraining={handleDeleteTraining} />
                  <PaginationControls page={page} totalPages={totalPages} onPageChange={setPage} />
                </>
              )}
            </>
          )}
        </Col>
        <Col md={12}>
          {/* <h2>Actions</h2> */}
          <ActionsSection />
        </Col>
      </Row>
    </Container>
  );
}

export default Trainings;
